<template>
    <div class="diagnosis-section">
      <div class="diagnosis-content">
        <h1 class="title-diagnosis-page">Cómo funciona</h1>
        <p class="description-diagnosis-page">
            Inicia una conversación por WhatsApp, haz el test gratuito para ti o tu hijo, y recibe acompañamiento directo de nuestro agente virtual Talentinus IA o de una especialista, según lo que necesites.
        </p>
        <a
          class="cta-button-big"
          href="https://api.whatsapp.com/send?phone=5215561461518&text=%C2%A1Quiero%20empezar%20mi%20diagn%C3%B3stico%20gratis!%F0%9F%98%80"
          target="_blank"
          rel="noopener"
        >
          INICIAR CONVERSACIÓN
        </a>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'DiagnosisSection'
  }
  </script>
  
  <style scoped>
  .diagnosis-section {
    width: 100%;
    height: 700px;
    /* background: url('../../assets/img/Talentinus\ Conocenos.png') no-repeat center center; */
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
  }
  
  .diagnosis-content {
    display: flex;
    max-height: 1400px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    text-align: center;
  }
  
  @media (max-width: 768px) {
  .diagnosis-section {
    height: auto;
    min-height: 320px;
    padding: 16px 0;
  }
  .diagnosis-content {
    gap: 16px;
    max-width: 100%;
    padding: 0 4vw;
  }
  .title-diagnosis-page {
    font-size: 1.3rem;
    margin-bottom: 6px;
    word-break: break-word;
  }
  .description-diagnosis-page {
    font-size: 1rem;
    margin-bottom: 10px;
    max-width: 100%;
    padding: 0 2vw;
    word-break: break-word;
  }
  .cta-button-big {
    width: 100%;
    font-size: 1rem;
    padding: 12px 0;
    margin-top: 6px;
    max-width: 350px;
  }
}
  
  </style>
